import { createContext, PropsWithChildren, useReducer } from "react";

import { CreateSourceFileUploadAction } from "@/pages/sources/components/create/sources/file-upload/actions";
import createSourceFileUploadReducer from "@/pages/sources/components/create/sources/file-upload/reducer";
import {
  CreateSourceFileUploadPhase,
  CreateSourceFileUploadState,
} from "@/pages/sources/components/create/sources/file-upload/types";

export interface CreateSourceFileUploadContextShape {
  state: CreateSourceFileUploadState;
  dispatch: React.Dispatch<CreateSourceFileUploadAction>;
}

export const DEFAULT_STATE: CreateSourceFileUploadState = {
  sourceName: "",
  files: [],
  phase: CreateSourceFileUploadPhase.IDLE,
  session: null,
  fileProgressMap: new Map(),
  overallProgress: 0,
  error: null,
  shouldShowErrors: false,
  isUploading: false,
};

export const CreateSourceFileUploadContext =
  createContext<CreateSourceFileUploadContextShape | null>(null);
CreateSourceFileUploadContext.displayName = "CreateSourceFileUploadContext";

const CreateSourceFileUploadProvider = ({ children }: PropsWithChildren) => {
  const [state, dispatch] = useReducer(createSourceFileUploadReducer, DEFAULT_STATE);

  return (
    <CreateSourceFileUploadContext.Provider value={{ state, dispatch }}>
      {children}
    </CreateSourceFileUploadContext.Provider>
  );
};

export default CreateSourceFileUploadProvider;
